import urlParse from 'url-parse';
import * as Routes from './routes';

/**
 * Function to get data (payload) from JWT token string
 * @param {string} token
 */
export function parseJWT(token) {
  return JSON.parse(window.atob(token.split('.')[1]));
}

/**
 * Handle access token, refresh token and lang slug when URI with tokens is
 * called in browser
 * @returns {string|boolean} - access token if success, false if not
 * @author jozef.repan
 */
export const handleTokens = () => {
  const currentURI = urlParse(window.location.href, true);
  const splitted = currentURI.hash.split('/');
  /* process language */
  if (splitted[3] !== undefined) {
    // lets suppose its a refresh token
    const lang = splitted[3];
    localStorage.setItem('current_lang', lang);
  }

  /* process refresh token */
  if (splitted[2] !== undefined) {
    // lets suppose its a refresh token
    const refreshToken = splitted[2];
    localStorage.setItem('refresh_token', refreshToken);
  }

  /* process access token */
  if (splitted[1] !== undefined) {
    // lets suppose its an access token
    const accessToken = splitted[1];
    localStorage.setItem('access_token', accessToken);
    return currentURI.pathname;
  }

  return false;
};

/**
 * @param {string} password a string to check
 * @param {obj} params with shape { minLenght<string>, oneDigit<boolean>, oneUpper<boolean>}
 * @author jozef.repan
 */
export const validatePassword = (
  password,
  { minLength, oneDigit, oneUpper }
) => {
  if (password === undefined) return false;
  // normalize password -> remove whitespaces
  const normalized = password.replace(/\s/g, '');
  // check if password is at least 8 characters long
  if (normalized.length < minLength) return false;
  // check if password contains one digit
  if (oneDigit && !/\d/.test(normalized)) return false;
  // check if password cointains on upper case
  if (oneUpper && !/[A-Z]/.test(normalized)) return false;

  return true;
};

/**
 * Checks if tokens are present in application
 * @returns {boolean} - do we have valid tokens for application?
 * @author jozef.repan
 */
export const checkTokens = () => {
  const accessToken = localStorage.getItem('access_token');
  const refreshToken = localStorage.getItem('refresh_token');
  return accessToken && refreshToken;
};

export const checkTokensWithRedirect = () => {
  if (!checkTokens()) {
    const url = new URL(window.location);

    const websiteUrl = localStorage.getItem('websiteUrl');
    if (websiteUrl) {
      window.location.href = websiteUrl;
      return;
    }

    const hostnameSplitted = url.hostname.split('.').reverse();
    window.location.href = `${url.protocol}//${hostnameSplitted[1]}.${
      hostnameSplitted[0]
    }`;
  }
};

/**
 * Redirects user to login window
 * @author jozef.repan
 */
export const redirectToLogin = () => {
  window.location.replace(Routes.LOGIN_URI);
};

/**
 * Removes tokens and redirects to login
 * @author jozef.repan
 */
export const logout = () => {
  // remove tokens
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  // redirect to login page
  redirectToLogin();
};
